import { render, staticRenderFns } from "./CommunityCallout.vue?vue&type=template&id=7bd932c8&lang=pug&"
import script from "./CommunityCallout.vue?vue&type=script&lang=ts&"
export * from "./CommunityCallout.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports